// extracted by mini-css-extract-plugin
export default {"alert":"index_alert__8dntB","icon":"index_icon__8snwK"};